import React from 'react';
//import '../../styles/Light.css'
//import '../../styles/Dark.css'
import LocalStorage from '../../providers/LocalStorage';
import DerivedState from './DerivedState'
import { Z_FILTERED } from 'zlib';
import SearchSelect from './SearchSelect';
import Ws from '../../providers/Ws';


export default class Test extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
            objTest:[{
                id:1,
                check:false,
                checkedText:'false'},
                {
                    id:2,
                    check:false,
                    checkedText:'false'},
                    {
                        id:3,
                        check:false,
                        checkedText:'false'},
                        {
                            id:4,
                            check:false,
                            checkedText:'false'}],

                            selectedValue:2,

        listaElemente:[
            {id:1, valoare:'Audi'},
            {id:2, valoare:'Bmw'},
            {id:3, valoare:'WV'},
            {id:4, valoare:'Dacia'},
            {id:5, valoare:'Volvo'},
            {id:6, valoare:'Subaru'},
            {id:7, valoare:'Mazda'},
            {id:8, valoare:'Mercedes'},
            {id:9, valoare:'Mitsubishi'},
            {id:10, valoare:'Honda'}
        ]
 
}   


        

    }
    componentDidMount(){
        // this.getDate()
        // this.getTheme()
        this.getTest()
    }


    getTest = async() =>{

        let ws = new Ws()

        let getData = await ws.customSelect('select * from distribuitori',{p1:1})

        console.log('getData :>> ', getData);


    }

    css = null

    getDate = () =>{


        let date = new Date();

        

        
        // console.log('date :', date);
    }

    // getTheme = () =>{
    //     console.log('changeTheme :');
    
    //     let ls = new LocalStorage();
    
    //     let theme = ls.GetUserPreferences().theme

    //     this.css = null
    
    //     if(theme === 'dark'){
    //         this.css = require('../../styles/Light.css')
    
    
    //     }else{
    //         this.css = require( '../../styles/Dark.css');
   

            
    //     }

      
    // }

    // changeTheme = () =>{
    //     console.log('changeTheme :');
    
    //     let ls = new LocalStorage();
    
    //     let theme = ls.GetUserPreferences().theme

    //     this.css = null
    
    //     if(theme === 'dark'){
    //         this.css = require('../../styles/Light.css')
    //     ls.SetUserPreferences('theme', 'light')
    
    //     }else{
    //         this.css = require( '../../styles/Dark.css');
    //    ls.SetUserPreferences('theme', 'dark')

            
    //     }

    //      document.location.reload();
    // }

    schimbaDate = (id) =>{
        // console.log('id :', id);
        
        let cloneTEst = [...this.state.objTest]

       let idx =cloneTEst.findIndex(i=>i.id === id)

     

       for(let i = 0 , n = cloneTEst.length ; i< n ; i++){
            if(i !== idx ){
                cloneTEst[i].check = false
                cloneTEst[i].checkedText = 'false'
            }
       }

       cloneTEst[idx].check = cloneTEst[idx].check === true ? false : true
       cloneTEst[idx].checkedText =  cloneTEst[idx].checkedText === 'true' ? 'false' : 'true'
       this.setState({objTest:cloneTEst})
    }
    

    apasa = () =>{
        if(true){
            let a = 5
        }

     
    }

    toServer= (e)=>{
        // console.log('elementSelectat :', e);
        this.setState({selectedValue:e.id})
    }

    
     render() { 
       return (
          <div>


        <SearchSelect 
            listaElemente={this.state.listaElemente}
            selectedValue={this.state.selectedValue}
            selectInitialValue={'Selecteaza Marca'}
            toServer={this.toServer}
            inputLabel={'Search Marca'}
           />
        {/* <div>sadasdsadadsadas</div> */}

              {/* {this.state.objTest.map((t,idx)=>{
                  return( 
                    <div style={{cursor:'pointer'}} key={idx} onClick={()=>{this.schimbaDate(t.id)}}>
                    <DerivedState
                    checked={t.check}
                    checkedText={t.checkedText}
                   
                  />
                    </div>  
                   )
              })}
            
                

      
            

             <h1 className='dark-test'>COLOR1</h1>
             <h2 className='light-test'>COLOR2</h2>



             <button onClick={this.changeTheme}>Change Theme</button>
 */}


        {/* <div id='constrainer'>
            <div className='scrolltable'>
                <table className='header'>
                    <thead>
                        <th>1</th>
                        <th>2</th>
                        <th>3</th>
                        <th>4</th>


                    </thead>
                </table>
                <div className='body'>
                    <table>
                        <tbody>
                            <tr>
                                <td>4</td>
                                <td>3</td>
                                <td>2</td>
                                <td>1</td>

                            </tr>
                            
                     
                   
                        </tbody>
                    </table>

                </div>

            </div>

        </div>

        <button onClick={this.apasa}>
            apasa
        </button> */}
             
         </div>
        );
       }
}